// Tiptap font families
const FONT_FAMILIES = [
  { label: 'Montserrat', value: 'Montserrat' },
  { label: 'Libre Baskerville', value: 'Libre Baskerville' },
  { label: 'Arial', value: 'arial, helvetica, sans-serif' },
  { label: 'Arial Black', value: 'arial black, avant garde' },
  { label: 'Book Antiqua', value: 'book antiqua, palatino' },
  { label: 'Comic Sans MS', value: 'comic sans ms, sans-serif' },
  { label: 'Courier New', value: 'courier new, courier' },
  { label: 'Georgia', value: 'georgia, palatino' },
  { label: 'Helvetica', value: 'helvetica' },
  { label: 'Tahoma', value: 'tahoma, arial, helvetica, sans-serif' },
  { label: 'Times New Roman', value: 'times new roman, times' },
  { label: 'Trebuchet MS', value: 'trebuchet ms, geneva' },
  { label: 'Verdana', value: 'verdana, geneva' },
  { label: 'Work Sans', value: 'work sans, sans-serif' },
];

// Tiptap font sizes
const FONT_SIZES = [
  '8pt', '9pt', '10pt', '11pt', '12pt', '14pt',
  '18pt', '24pt', '30pt', '36pt', '48pt', '60pt', '72pt', '96pt',
];

// Tiptap line height options
const LINE_HEIGHTS = [
  '1', '1.15', '1.2', '1.3', '1.4', '1.5',
  '1.6', '1.8', '2', '2.5', '3',
];

// Common emoji set for the emoji picker
const EMOJI_LIST = [
  '\u{1F600}', '\u{1F603}', '\u{1F604}', '\u{1F601}', '\u{1F606}',
  '\u{1F605}', '\u{1F602}', '\u{1F923}', '\u{1F60A}', '\u{1F607}',
  '\u{1F642}', '\u{1F643}', '\u{1F609}', '\u{1F60C}', '\u{1F60D}',
  '\u{1F970}', '\u{1F618}', '\u{1F617}', '\u{1F619}', '\u{1F61A}',
  '\u{1F60B}', '\u{1F61B}', '\u{1F61C}', '\u{1F92A}', '\u{1F61D}',
  '\u{1F911}', '\u{1F917}', '\u{1F92D}', '\u{1F92B}', '\u{1F914}',
  '\u{1F910}', '\u{1F928}', '\u{1F610}', '\u{1F611}', '\u{1F636}',
  '\u{1F60F}', '\u{1F612}', '\u{1F644}', '\u{1F62C}', '\u{1F925}',
  '\u{1F60E}', '\u{1F929}', '\u{1F913}', '\u{1F9D0}', '\u{1F615}',
  '\u{1F61F}', '\u{1F641}', '\u2639\uFE0F', '\u{1F62E}', '\u{1F62F}',
  '\u{1F632}', '\u{1F633}', '\u{1F97A}', '\u{1F626}', '\u{1F627}',
  '\u{1F628}', '\u{1F630}', '\u{1F625}', '\u{1F622}', '\u{1F62D}',
  '\u{1F631}', '\u{1F616}', '\u{1F623}', '\u{1F61E}', '\u{1F613}',
  '\u{1F629}', '\u{1F624}', '\u{1F621}', '\u{1F620}', '\u{1F92C}',
  '\u2764\uFE0F', '\u{1F49B}', '\u{1F49A}', '\u{1F499}', '\u{1F49C}',
  '\u{1F5A4}', '\u{1F44D}', '\u{1F44E}', '\u{1F44F}', '\u{1F64C}',
  '\u{1F44A}', '\u270A', '\u{1F91E}', '\u270C\uFE0F', '\u{1F91F}',
  '\u{1F918}', '\u{1F44C}', '\u{1F448}', '\u{1F449}', '\u{1F446}',
  '\u{1F447}', '\u261D\uFE0F', '\u270B', '\u{1F91A}', '\u{1F590}\uFE0F',
  '\u{1F596}', '\u{1F44B}', '\u{1F919}', '\u{1F4AA}', '\u{1F64F}',
  '\u2B50', '\u{1F31F}', '\u{1F4A5}', '\u{1F525}', '\u26A1',
  '\u{1F308}', '\u2600\uFE0F', '\u{1F324}\uFE0F', '\u26C5',
  '\u{1F327}\uFE0F', '\u2744\uFE0F',
  '\u{1F389}', '\u{1F388}', '\u{1F381}', '\u{1F3C6}', '\u{1F3B5}',
  '\u{1F3B6}', '\u{1F4F7}', '\u{1F4BB}', '\u{1F4F1}', '\u2705',
  '\u274C', '\u2757', '\u2753', '\u{1F4A1}', '\u{1F4AC}',
];

// Special characters for the character map
const CHAR_MAP = [
  '\u00A9', '\u00AE', '\u2122', '\u00B0', '\u00B1', '\u00F7',
  '\u00D7', '\u2260', '\u2248', '\u221E', '\u00BD', '\u00BC',
  '\u00BE', '\u2153', '\u2154', '\u00B2', '\u00B3', '\u00B9',
  '\u2190', '\u2192', '\u2191', '\u2193', '\u2194', '\u2195',
  '\u21D0', '\u21D2', '\u21D1', '\u21D3', '\u21D4', '\u21D5',
  '\u2713', '\u2717', '\u2022', '\u25CF', '\u25CB', '\u25A0',
  '\u25A1', '\u25B2', '\u25B3', '\u25BC', '\u25BD', '\u2605',
  '\u2606', '\u2660', '\u2663', '\u2665', '\u2666', '\u266A',
  '\u266B', '\u00A7', '\u00B6', '\u2020', '\u2021', '\u2026',
  '\u2030', '\u20AC', '\u00A3', '\u00A5', '\u00A2', '\u20BD',
  '\u03B1', '\u03B2', '\u03B3', '\u03B4', '\u03B5', '\u03B6',
  '\u03B8', '\u03BB', '\u03BC', '\u03C0', '\u03C3', '\u03C6',
  '\u03C8', '\u03C9', '\u0394', '\u03A3', '\u03A9', '\u03A6',
  '\u2200', '\u2203', '\u2205', '\u2208', '\u2209', '\u2229',
  '\u222A', '\u2282', '\u2286', '\u2227', '\u2228', '\u00AC',
];

export {
  FONT_FAMILIES,
  FONT_SIZES,
  LINE_HEIGHTS,
  EMOJI_LIST,
  CHAR_MAP,
};
